import { render, staticRenderFns } from "./OkCancelWithComments.vue?vue&type=template&id=c6752a00&scoped=true"
import script from "./OkCancelWithComments.vue?vue&type=script&lang=js"
export * from "./OkCancelWithComments.vue?vue&type=script&lang=js"
import style0 from "./OkCancelWithComments.vue?vue&type=style&index=0&id=c6752a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6752a00",
  null
  
)

export default component.exports